import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const PREREQS = [
  'Python proficiency (functions, classes, typing, packaging)',
  'Git & GitHub — branching, PRs, basic CI',
  'HTTP/REST & JSON — calling and building a simple API',
  'SQL basics — joins, aggregates, relational schemas',
  'Command line & Docker basics',
  'About 10 hours a week for 6 months',
];

const PREWORK = [
  'Lab-stack setup — Docker, Python, Node; bring up the standard lab stack; API keys via the program gateway',
  'Python-for-production-AI refresher (typing/Pydantic, async, packaging)',
  'ML concepts primer (bias/variance, metrics, model families)',
];

const PreWork = () => {
  return (
    <section id="prework" className={styles.mint}>
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Pre-work &amp; <span className={styles.g}>prerequisites.</span>
        </h2>
        <p className={styles.secSub}>
          You need to be a working programmer. You don&apos;t need ML, deep-learning or LLM
          experience — the refreshers are built in.
        </p>
        <div className={styles.grid2}>
          <div className={styles.tile}>
            <span className={styles.tag}>Prerequisites</span>
            <ul>
              {PREREQS.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className={styles.tile}>
            <span className={styles.tag}>Pre-work · ≈ 8–10 hours, self-paced</span>
            <ul>
              {PREWORK.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p style={{ marginTop: 12 }}>
              Provisioned before Day 1: an AWS sandbox with budget alarms, LLM API access behind a
              gateway, the lab stack and a lab kit for all 17 builds. <b>We use free tiers and
              resources wherever sufficient.</b>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreWork;
